import React from 'react'
import { useSelector } from 'react-redux';
import { selectItemById } from './postsSlice';

import PostAuthor from './PostAuthor';
import TimeAgo from './TimeAgo';
import ReactionButtons from './ReactionButtons';
import { FaCircle } from 'react-icons/fa'

import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

const SinglePostPage = () => {
  const { postId } = useParams();

  const post = useSelector((state) => selectItemById(state, Number(postId)));

  if(!post){
    return(
      <section>
        <h2>Post not found</h2> 
      </section>
    )
  }

  
  return (
    <article> 
      <h3><FaCircle />{post.title}</h3>
      <p><Link to={`/posts/edit/${post.id}`}>Edit post</Link></p>  {/* changed from post */}
      <small>
        <PostAuthor userId={post.userId}/>  
        <TimeAgo timestamp={post.date}/>
      </small>
      <p>{post.content}</p>
      <ReactionButtons post={post}/>
    </article>
  )
}

export default SinglePostPage